import React from 'react'

const AudioBarContext = React.createContext({ path: null, setPath: () => {} })

export default AudioBarContext
